import { Component, Inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EmpDetails } from '@aptsi-types';
import { IdentityProvisioningService } from '../../identity-provisioning/identity-provisioning.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { startWith } from 'rxjs/operators';
import { SuccessDialogComponent } from '../../shared/dialogs/success-dialog/success-dialog.component';
import { EnvironmentService } from 'src/app/core/service/environment.service';
@Component({
  selector: 'app-transfer-org-unit',
  templateUrl: './transfer-org-unit.component.html',
  styleUrls: ['./transfer-org-unit.component.scss']
})
export class TransferOrgUnitComponent {
  form: FormGroup;
  empDetails: EmpDetails[] = [];

  verify: string;
  readonly organizationOptions = ['Acme corp 1', 'Acme corp 2', 'Acme corp 3', 'None'];
  readonly organizationUnitOptions = ['Sales', 'Marketing', 'Engineering', 'All'];

  filteredCurrentOrgOptions: string[] = [];
  filteredNewOrgOptions: string[] = [];

  constructor(
    private router: Router, 
    private identityProvisioningService: IdentityProvisioningService, 
    private route: ActivatedRoute, 
    private dialog: MatDialog,
    public environmentService: EnvironmentService) { }

  async ngOnInit(): Promise<void> {
    this.form = new FormGroup({
      currentOrganization: new FormControl('None', [Validators.required, this.typeValidatorFactory()]),
      newOrganization: new FormControl('None', [Validators.required, this.typeValidatorFactory()]),
      organizationUnit: new FormControl('All'),
    });

    // Initialize filtered options
    this.filteredCurrentOrgOptions = this.organizationOptions;
    this.filteredNewOrgOptions = this.organizationOptions;

    this.form.get('currentOrganization').valueChanges.pipe(
      startWith(this.form.get('currentOrganization').value)
    ).subscribe(selectedCurrentOrg => {
      this.filteredNewOrgOptions = this.organizationOptions.filter(option => option === 'None' || option !== selectedCurrentOrg);
    });

    this.form.get('newOrganization').valueChanges.pipe(
      startWith(this.form.get('newOrganization').value)
    ).subscribe(selectedNewOrg => {
      this.filteredCurrentOrgOptions = this.organizationOptions.filter(option => option === 'None' || option !== selectedNewOrg);
    });

  }

  typeValidatorFactory() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const selectedType = control.value;
      if (selectedType === 'None') {
        return { 'noneSelected': true };
      }
      return null;
    };
  }


  async transfer() {
    const response = await this.identityProvisioningService.transferOrgUnitDetail(
      this.form.value.currentOrganization,
      this.form.value.newOrganization,
      this.form.value.organizationUnit,

    ).toPromise();
    this.openSuccessDialog();
  }


  back() {
    this.router.navigate(['digital-identity/auth-tools/identity-admin-panel']);
  }


  openSuccessDialog(): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: '250px',
      data: {
        isMessage: true,
        isCreateUpdate: false,
        title: "Organization Unit Transfered Successfully",
        subTitle:
          "The Organization Unit has been successfully transferred.",
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['digital-identity/auth-tools/identity-admin-panel']);
    });
  }
}



